import styled, { css } from 'styled-components';

const commonFlex = css`
  display: flex;
  flex-direction: column;
`;

export const BodyWrapper = styled.div`
  ${commonFlex}
  gap: 20px;
`;
